import { ContentfulDataType } from 'types';
import RestUtility from '../../restUtility';
import { contentfulEndPoint } from '../../restUtility/restEndpoints';

export class ContentfulService {
  private restUtility: RestUtility;

  constructor() {
    this.restUtility = new RestUtility();
    this.getContentfulData = this.getContentfulData.bind(this);
  }

  async getContentfulData(locale?: string, contentTypes?: string[]) {
    const response = await this.restUtility.post<ContentfulDataType>(
      `${contentfulEndPoint}`,
      {
        locale: locale,
        contentTypes: contentTypes,
      }
    );

    return response;
  }
}
